import React from 'react'
import diamond from './assets/diamond.png'
import number from './assets/number.jpg'
const Twenty_one = () => {
    return (
        <div className='container'>
            <h1>Diamond shape pattern </h1>
            <p>These type of patterns contain two things first they will make
            pyramid in upward direction then after reacching n they will make pyramid downwards
            </p>
            <h3>Print Stars pyramid pattern </h3>
            <div className='containers'>
                Given a number n, write a program to print a diamond shape with 2n rows. <br />
                <img src={diamond} alt="" />
            </div>
            <h3>Algorithm to print the pattern </h3>
            <ol>
                <li>By seeing the pattern we know that user wants to print pattern till 10th row and input is half of it so we to deal with 2n rows</li>
                <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing number from row number to row to number,<br />
                    <b>1st column</b>: nth value =1 print = *   <br />
                    <b>2nd column</b>: nth value =2 print = * * <br />
                    <b>3rd column</b>:nth value =3  print = * * * <br />
                    <b>4th column</b>:nth value =4  print = * * * *<br />
                    <b>5th column</b>:nth value =5  print =* * * * *<br />
                    <b>6th column</b>:nth value =6  print =* * * * *<br />
                    <b>7th column</b>:nth value =7  print =* * * * <br />
                    <b>8th column</b>:nth value =8  print =* * * <br />
                    <b>9th column</b>:nth value =9  print =* *  <br />
                    <b>10th column</b>:nth value =10  print =* <br />
                </li>
                <li>in this type of pattern you have to focus on spaces also that how the spaces are printing</li>
                <li>We can see that space are printing in pattern n-1 so we can initialize space by  int space = n - 1;</li>
                <li>You will observe that till in each column number is increasing till middle after they start to decrease till row number </li>
                <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till n.</li>
                <li> we will initialize a variable N which takes the input from user </li>
                <li>Then we will intialize a for loop <b>for(int row=0;row &gt;=n ;row++)</b> this will print row till N </li>
                <li>another for loop we will initalize another for loop <b>for(int column=0;column&gt;=space;column++)</b> this will print spaces in each row</li>
                <li>another for loop we will initalize another for loop <b>for(int column=0;column&gt;=row;column++)</b> this will print stars in each row</li>
            </ol>
            <div className='containers'>
                <code class="library">#include &lt;stdio.h&gt;</code> <br />
                <code class="comment">// Prints diamond</code><br />
            <code class="comment">// pattern with 2n rows</code><br />
            <code class="keywords">void</code> printDiamond(int n)<br />
&#123;<br />
            <code class="keywords">  int</code> space = n - 1;<br />
            <br />
            <code class="comment"> // run loop</code> <br />
            <code class="lcomment"> // till number of rows</code><br />
            <code class="keywords"> for</code> (int i = 0; i &lt; n; i++)<br />
    &#123;<br />
            <code class="comment">   // loop for initially space,</code><br />
            <code class="commment">  // before star printing</code><br />
            <code class="keywords">  for </code>(int j = 0;j &lt; space; j++)<br />
            <code class="library">    printf</code>(" ");<br />

            <code class="comment"> // Print i+1 stars</code><br />
            <code class="keyword"> for </code>(int j = 0;j &lt;= i; j++)<br />
            <code class="library">   printf</code>("* ");<br />

            <code class="library"> printf</code>("\n");<br />
        space--;<br />
    &#125;<br />
            <br />
            <code class="comment">// Repeat again in</code><br />
            <code class="comment">// reverse order</code><br />
    space = 0;<br />

            <code class="comment"> // run loop (parent loop)</code><br />
            <code class="comment"> // till number of rows</code><br />
            <code class="keywords"> for</code> (int i = n; i &gt; 0; i--)<br />
    &#123;<br />
            <code class="comment">     // loop for initially space,</code><br />
            <code class="comment">   // before star printing</code><br />
            <code class="library">   for </code>(int j = 0; j &lt; space; j++)<br />
            <code class="library">       printf</code>(" ");<br />
            <br />
            <code class="comment">   // Print i stars</code><br />
            <code class="keywords">  for</code> (int j = 0;j &lt; i;j++)<br />
            <code class="library">   printf</code>("* ");<br />
            <br />
            <code class="library">printf</code>("\n");<br />
        space++;<br />
    &#125;<br />
&#125;<br />
            <code class="comment"> //main function</code><br />
            <code class="keywords">int</code> main()<br />
&#123;<br />
    printDiamond(5);<br />
            <code class="library"> return</code> 0;<br />
&#125;<br />
        </div>
        <h3>Alphabatical diamond pattern</h3>
        <div className='containers'>
        Write a program to create the following Pyramid using C program? <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;A B <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A B C <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A B C D<br />
        &nbsp;&nbsp;&nbsp;&nbsp; A B C D E<br />
        &nbsp;&nbsp;&nbsp; A B C D E F <br />
        &nbsp;&nbsp;&nbsp;&nbsp; A B C D E <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A B C D <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A B C <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A B <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A <br />
        </div>
        <h3>Algorithm to print the pattern </h3>
            <ol>
                <li>By seeing the pattern we know that user wants to print pattern till 10th row and input is half of it so we to deal with 2n rows</li>
                <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing number from row number to row to number,<br />
                    <b>1st column</b>: nth value =1 print = A    <br />
                    <b>2nd column</b>: nth value =2 print = A B  <br />
                    <b>3rd column</b>:nth value =3  print = A B C <br />
                    <b>4th column</b>:nth value =4  print = A B C D<br />
                    <b>5th column</b>:nth value =5  print =A B C D E<br />
                    <b>6th column</b>:nth value =6  print =A B C D E F<br />
                    <b>7th column</b>:nth value =7  print =A B C D E F<br />
                    <b>8th column</b>:nth value =8  print =A B C D E<br />
                    <b>9th column</b>:nth value =9  print =A B C D  <br />
                    <b>10th column</b>:nth value =10  print =A B C  <br />
                    <b>11th column</b>:nth value =10  print =A B   <br />
                    <b>12th column</b>:nth value =10  print =A   <br />
                </li>
              <li>the logic will be same as above pattern here we just repalce the star with character to print alphabet</li>
            </ol>
            <div className='containers'>
            <code class="library">#include &lt;stdio.h&gt;</code> <br />
            
<code class="library">#include &lt;conio.h&gt;</code> <br />
<code class="keywords"> int</code> main() <br />
&#123; <br />
<code class="keywords">  int</code> row, column, n, space; <br />
<code class="keywords"> char</code> ch='A'; <br />
<code class="library"> printf</code>("Enter Number of ns: "); <br />
<code class="library">scanf</code>("%d", &n); <br />
    space = n-1; <br />
    <code class="keywords">for</code>(int row=1; row&lt;=n; row++) <br />
    &#123; <br />
    <code class="keywords">  for</code>(column=1; column&lt;=(space); column++) <br />
    <code class="library">     printf</code>(" "); <br />
        space--; <br />
        <code class="keywords"> for</code>(column=1; column&lt;=(2*row-1); column++) <br />
        &#123; <br />
        <code class="library"> printf</code>("%c", ch); <br />
            ch++; <br />
        &#125; <br />
        <code class="keywords"> ch</code>='A'; <br />
        <code class="library"> printf</code>("\n"); <br />
    &#125; <br />
  space = 1; <br />
    <code class="keywords">for</code>(row=1; row&lt;=(n-1); row++) <br />
    &#123; <br />
    <code class="keywords">   for</code>(column=1; column&lt;=(space); column++) <br />
    <code class="library">    printf</code>(" "); <br />
        space++; <br />
        <code class="keywords">  for</code>(column=1; column&lt;=(2*(n-row)-1); column++) <br />
        &#123; <br />
        <code class="library">   printf</code>("%c", ch); <br />
            ch++; <br />
        &#125; <br />
        ch='A'; <br />
        <code class="library"> printf</code>("\n"); <br />
    &#125; <br />
    <code class="function"> getch();</code> <br />
    <code class="library"> return 0; </code><br />
&#125; <br />
            </div>
            <h3>Diamond of  numbers</h3>
            <div  className='containers'> C Program to Print the Diamond Pattern of Numbers <br />
            <img src={ number } alt="" /></div>
            <h3>Algorithm to print the pattern </h3>
            <ol>
                <li>Same as above  just change the char to num</li>
            </ol>
            <div className='containers'>
                
<code class="library">#include &lt;stdio.h&gt;</code> <br />
<code class="library"></code>int main()<br />
&#123;<br />
<code class="library">  int</code> n, a;<br />

<code class="library"> printf</code>("Enter number of rows: ");<br />
<code class="library"> scanf</code>("%d",&n);<br />

<code class="comment">// for first half portion</code> <br />
<code class="comment">// from top to bottom</code><br />
<code class="keywords">for</code>(int i=1; i&lt;s=n; i++)<br />
   &#123;<br />
   <code class="comment"> // In each iteration a will</code><br />
   <code class="comment"> // start from 1</code><br />
     a = 1;<br />

     <code class="comment">// print space</code><br />
     <code class="keywords">for</code>(int j=i; j &lt;s= n; j++)<br />
     &#123;<br />
     <code class="library">  printf</code>(" ");<br />
     &#125;<br />

     // print digit<br />
     <code class="keywords"> for</code>(int k=1; k &lt;s= 2*i-1; k++)<br />
     &#123;<br />
     <code class="library">   printf</code>("%d",a++);<br />
     &#125;<br />

     <code class="comment"> // new line</code><br />
     <code class="library"> printf</code>("n");<br />
   &#125;<br />

   // for second portion <br />
   <code class="keywords"> for</code>(int i=n-1; i&gt;=1; i--)<br />
   &#123;<br />
   <code class="comment">// In each iteration a will</code><br />
   <code class="comment">// start from 1</code><br />
     a=1;<br />
     <br />
     <code class="comment"> // print space</code><br />
     <code class="keywords"> for</code>(int j=n; j&gt;=i; j--)<br />
     &#123;<br />
     <code class="library">   printf</code>(" ");<br />
     &#125;<br />

     <code class="comment"> // print digit</code><br />
     <code class="keywords"> for</code>(int k=1; k&lt;s=2*i-1; k++)<br />
     &#123;<br />
     <code class="library">   printf</code>("%d",a++);<br />
     &#125;<br />
     <br />
     <code class="comment">// new line</code><br />
     <code class="library"> printf</code>("\n");<br />
   &#125;<br />
   <br />
   <code class="library"> return</code> 0;<br />
&#125;
            </div>
        </div >
         
    )
}

export default Twenty_one
